import React from 'react';
interface MockupBookProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: 'terracota' | 'salvia' | 'dorado' | 'oscuro';
  size?: 'sm' | 'lg';
}
export function MockupBook({
  title,
  subtitle,
  icon,
  color = 'terracota',
  size = 'lg'
}: MockupBookProps) {
  const colors = {
    terracota: 'bg-terracota text-white border-terracota-dark',
    salvia: 'bg-salvia text-white border-salvia-light',
    dorado: 'bg-dorado text-oscuro border-yellow-600',
    oscuro: 'bg-oscuro text-white border-gray-900'
  };
  const sizes = {
    sm: 'w-32 h-44 p-3 text-xs',
    lg: 'w-64 h-80 p-6 text-base'
  };
  return <div className={`relative rounded-r-xl rounded-l-sm shadow-xl flex flex-col justify-between overflow-hidden border-l-8 ${colors[color]} ${sizes[size]} transform transition-transform hover:-translate-y-2`} data-id="element-258">
      {/* Spine effect */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-black/20" data-id="element-259" />

      {/* Cover content */}
      <div className="relative z-10 flex flex-col h-full" data-id="element-260">
        <div className="flex-1" data-id="element-261">
          {icon && <div className={`mb-3 ${size === 'lg' ? 'scale-150 origin-top-left' : ''}`} data-id="element-262">
              {icon}
            </div>}
          <h3 className={`font-bold leading-tight ${size === 'lg' ? 'text-2xl mb-2' : 'text-sm mb-1'}`} data-id="element-263">
            {title}
          </h3>
          {subtitle && <p className={`opacity-90 leading-snug ${size === 'lg' ? 'text-sm' : 'text-[10px]'}`} data-id="element-264">
              {subtitle}
            </p>}
        </div>

        <div className="mt-auto pt-4 border-t border-white/20" data-id="element-265">
          <p className={`font-bold tracking-widest uppercase ${size === 'lg' ? 'text-xs' : 'text-[8px]'}`} data-id="element-266">
            YOGA 360™
          </p>
        </div>
      </div>

      {/* Decorative gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent pointer-events-none" data-id="element-267" />
    </div>;
}